<template>
  <div class="reservation-calendar">
    <calendar-input class="zindex-2" :field="date" @change="changeDate" ref="calendar"></calendar-input>
    <div class="box-header no-radius">
      <div class="box-title">Availability for #{{ originalReservation.Car.convadisId }} ({{ originalReservation.Car.name }}) - {{ date.value | short_date_format_day }}</div>
    </div>
    <div class="row">
      <div class="col-sm-6 no-right-gutter">
        <div class="calendar">
          <div class="container-fluid">
            <div v-for="time in times" class="row">
              <div class="col-xs-2 availability-table">
                {{ time.hour | to_calendar_time }}
              </div>
              <div class="col-xs-10 no-left-gutter">
                <template v-for="item in time.booked">
                  <div @click="viewRes(item.reservation)" v-if="item" class="booked"
                  :class="{
                    'start': item.position == 'start',
                    'end': item.position == 'end',
                    'selected': item.reservation.reservationId == selectedReservation.reservationId
                    }">
                  </div>
                  <div v-else class="available"></div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="reservation-box">
          <reservation-display :data="selectedReservation"></reservation-display>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .box-header.no-radius {
    border-radius: 0px;
    margin-top: 10px;
  }
  .zindex-2 .pika-single{
    z-index: 2 !important;
  }
  .booked {
    background: #0d4081;
    height: 10px;
    width: 100%;
    cursor: pointer;
  }
  .available {
    height: 10px;
    width: 100%;
    border-bottom: 1px dotted #bbb;
  }
  .start {
    border-top-right-radius: 4px;
    position: relative;
  }
  .end {
    border-bottom-right-radius: 4px;
  }
  .availability-table {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
  }
  .selected {
    background: #4CAF50;
  }
  .reservation-box, .calendar {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    padding: 20px 10px;
    margin: 10px;
  }
  .reservation-box {
    border: 10px solid #4CAF50;
    border-radius: 4px;
  }
  .no-right-gutter {
    padding-right: 0;
  }
  .no-left-gutter {
    padding-left: 0;
  }
</style>

<script>
import CalendarInput from '../inputs/CalendarInput.vue'
import ReservationDisplay from '../displays/ReservationDisplay.vue'
import moment from 'moment-timezone'
export default {
  name: 'ReservationCalendar',
  data () {
    return {
      times: [],
      selectedReservation: {
        Account: {
          uuid: '',
          dropdownLabel: '',
          AccountType: {},
          Smartcard: {}
        },
        Car: {
          uuid: '',
          dropdownLabel: ''
        }
      },
      originalReservation: {
        Account: {
          uuid: '',
          dropdownLabel: '',
          AccountType: {},
          Smartcard: {}
        },
        Car: {
          uuid: '',
          dropdownLabel: ''
        }
      },
      date: {
        name: 'date',
        label: 'Select a Date',
        type: 'date',
        value: new Date()
      },
      reservations: [],
      resTimes: []
    }
  },
  components: {
    CalendarInput,
    ReservationDisplay
  },
  methods: {
    presentReservation (reservation) {
      this.selectedReservation = reservation
      this.originalReservation = reservation
      this.date.value = moment(reservation.startDate).tz(reservation.Lot.timezone).toDate()
      this.$refs.calendar.setDate(this.date.value)
      this.getReservations()
    },
    changeDate (val) {
      this.date.value = val
      this.getReservations()
    },
    viewRes (res) {
      this.selectedReservation = res
    },
    getReservations () {
      let params = {
        date: moment(this.date.value).valueOf(),
        carId: this.originalReservation.Car.uuid
      }
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/reservations`, { params }).then(({ data }, status, request) => {
        this.reservations = data.object
        this.times = []
        this.resTimes = []
        for (let i = 0; i < 24; i++) {
          this.times.push({
            hour: i,
            booked: {
              0: false,
              15: false,
              30: false,
              45: false
            }
          })
        }
        let resCounter = 0
        for (let reservation of this.reservations) {
          let counter = 0
          let resStart = moment(reservation.startDate).tz(reservation.Lot.timezone)
          let resEnd = moment(reservation.endDate).tz(reservation.Lot.timezone)
          let dayStart = moment(this.date.value).set({ hour: 0, minute: 0, second: 0 })
          let dayEnd = moment(this.date.value).set({ hour: 23, minute: 59, second: 59 })
          if (resStart.isSameOrBefore(dayStart)) {
            resStart = dayStart
          }
          if (resEnd.isSameOrAfter(dayEnd)) {
            resEnd = dayEnd
          }
          let start = resStart.clone()
          while (start.isBefore(resEnd)) {
            this.resTimes.push({
              hour: start.hour(),
              minute: start.minute(),
              reservation
            })
            if (counter === 0) {
              this.resTimes[resCounter].position = 'start'
            }
            counter++
            resCounter++
            start.add(15, 'minutes')
          }
          // this.resTimes[this.resTimes.length - 1].position = 'end'
          for (let time of this.times) {
            for (let res of this.resTimes) {
              if (time.hour === res.hour) {
                time.booked[res.minute] = res
              }
            }
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/ReservationCalendar.vue